import getApiClient from "./../../../../shared/api";

export const FETCH_BACKGROUND_CHARACTER_COSTUMES = "FETCH_BACKGROUND_CHARACTER_COSTUMES";

export function fetchBackgroundCharacterCostumes(filmId, characterId) {
  return (dispatch) => {
    dispatch({
      type: FETCH_BACKGROUND_CHARACTER_COSTUMES,
      payload: getApiClient().get(`/film/${filmId}/backgroundCharacter/${characterId}/costumes`)
    });
  };
}
